import * as React from "react";

export class StakeValue extends React.Component<{
    stakeValue: string
}, {}> {

    render() {
        return (
            <div className="rj-my-pulse-bets__stake-value">
                <span>{this.props.stakeValue}</span>
            </div>
        )
    }
}